import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'carm-deployment-warning-modal',
  templateUrl: './deployment-warning-modal.component.html',
  styleUrls: ['./deployment-warning-modal.component.scss'],
})
export class DeploymentWarningModalComponent implements OnInit, OnDestroy{


  remainingTime: { minutes: number; seconds: number } = { minutes: 0, seconds: 0 };
  private timerSubscription: Subscription | null = null;

  constructor(
    public dialogRef: MatDialogRef<DeploymentWarningModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
        dialogRef.disableClose = true;
    }


  ngOnInit() {
      this.startTimer();
  }


  private startTimer() {
    this.updateRemainingTime(); // Initial calculation

    this.timerSubscription = interval(1000).subscribe(() => {
      this.updateRemainingTime();
    });
  }

  private stopTimer() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }

  private updateRemainingTime() {
    const deploymentTime = localStorage.getItem('nextDeploymentTime');
    if (deploymentTime) {
      const deploymentDate = new Date(deploymentTime);
      const now = new Date();
      const remainingMilliseconds = deploymentDate.getTime() - now.getTime();

      const remainingSeconds = Math.max(0, Math.floor(remainingMilliseconds / 1000));

      this.remainingTime.minutes = Math.floor(remainingSeconds / 60);
      this.remainingTime.seconds = remainingSeconds % 60;
    }
  }

  closeModal() {
    localStorage.setItem("warn-deployment","1");
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.stopTimer();
  }
}
